import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from 'semantic-ui-react';
import { getApplicationPhotos } from '../../../app/firestore/firestoreService';
import {
  fetchApplicationBySlug,
  listenToApplicationPhotos,
} from '../libraryActions';
import ApplicationDetailedAdvanced from './ApplicationDetailedCategories';
import ApplicationDetailedReview from './ApplicationDetailedReview';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import { Redirect } from 'react-router-dom';
import useFirestoreCollection from '../../../app/hooks/useFirestoreCollection';
import ApplicationDetailedHeader from './ApplicationDetailedHeader';
import PageMetaData from '../../../app/common/elements/PageMetaData';
import { useEffect } from 'react';
import { Fragment } from 'react';

export default function ApplicationDetailedPageBySlug({ match }) {
  const dispatch = useDispatch();
  const { selectedApplication } = useSelector((state) => state.library);
  const { loading, error } = useSelector((state) => state.async);
  const { photos } = useSelector((state) => state.library);

  useEffect(() => {
    dispatch(fetchApplicationBySlug(match.params.slug));
  }, [dispatch, match.params.slug]);

  let shouldExecute = true;
  if ((loading && !selectedApplication) || (!selectedApplication && !error))
    shouldExecute = false;

  useFirestoreCollection({
    query: () => getApplicationPhotos(selectedApplication),
    data: (photos) => dispatch(listenToApplicationPhotos(photos)),
    deps: [selectedApplication, dispatch],
    shouldExecute: shouldExecute,
  });

  if ((loading && !selectedApplication) || (!selectedApplication && !error))
    return <LoadingComponent content='Loading profile...' />;

  if (error) return <Redirect to='/error' />;

  return (
    <Fragment>
      <PageMetaData
        title={`${selectedApplication.title} Review`}
        description={
          selectedApplication.intro &&
          selectedApplication.intro.replace(/<[^>]+>/g, '')
        }
        url={`/view/${selectedApplication.slug}`}
      />
      <Grid>
        <Grid.Column
          width={16}
          style={{ textAlign: 'center' }}
          className='pageHeader'
        >
          <h1 className='pageTitle' style={{ verticalAlign: 'middle' }}>
            {selectedApplication.title} Reviews
          </h1>
        </Grid.Column>
      </Grid>
      <Grid className='pageBody'>
        <Grid.Row>
          <Grid.Column width={16}>
            <Grid.Column width={16}>
              <ApplicationDetailedHeader
                application={selectedApplication}
                photos={photos}
              />
            </Grid.Column>
            <Grid.Column width={16} style={{ marginTop: '15px' }}>
              <ApplicationDetailedAdvanced
                languages={selectedApplication.language}
                levels={selectedApplication.level}
                media_type={selectedApplication.media_type}
                skills={selectedApplication.skills}
              />
            </Grid.Column>
          </Grid.Column>
          {/* <Grid.Column width={4}>
            <ApplicationDetailedSidebar
              application={selectedApplication}
            />
          </Grid.Column> */}
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={16}>
            <ApplicationDetailedReview
              title={selectedApplication.title}
              loading={loading}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Fragment>
  );
}
